/* eslint-disable */
import React from "react"
import HamburgerMenuIcon from "../../components/compounds/HamburgerMenuIcon.compound"
import { BREAKPOINTS } from "../../consts/responsiveBreakpoints.consts"
import { ReactComponent as AIKAMobileLogoIcon } from "../../design/assests/images/icons/AIKA-mobile-logo.svg"
import useSidebarContext from "../../hooks/contextConsumers/useSidebarContext.hook"
import useScreenDimensionsContext from "../../hooks/contextConsumers/useScreenDimensionsContext.hook"
import { useSession } from "../../hooks/auth/useSession.hook"
import UserMenu from "../../components/compounds/UserMenu"
import ClockCDMX from "../../components/compounds/ClockCDMX.compound"

export default function ResponsiveTopBar(props) {
  const { setSidebarActive } = useSidebarContext()
  const { screenWidth } = useScreenDimensionsContext()

  if (screenWidth <= BREAKPOINTS.TABLET_BREAKPOINT) {
    return (
      <>
        <div className={`mobile-top-bar`}>
          <div className="flex gap-2 align-items-center">
            <HamburgerMenuIcon activateSidebar={() => setSidebarActive(true)} />
            <ClockCDMX isResponsive/>
          </div>
          <AIKAMobileLogoIcon className={"AIKA-mobile-logo-icon"} />
          <UserMenu />
        </div>
      </>
    )
  }
}
